export function sortYoutubeVideo(url: string) {
  const videoId = url?.split('v=')[1];

  return `https://www.youtube.com/embed/${videoId}?autoplay=1&mute=1&cc_lang_pref=pt&cc_load_policy=1`;
}

